module.exports = __webpack_public_path__ + "static/media/011.d7ec8a35.jpg";